import { useInView } from 'react-intersection-observer';

/**
 * Detects when an element with `position: sticky` has become stuck.
 *
 * Place the returned `sentinelRef` on a zero-height element rendered
 * immediately before the sticky element. When the sentinel scrolls past
 * `topOffset` pixels from the top of the viewport (i.e. the point at which
 * the sticky element locks in place), `isSticky` becomes `true`.
 *
 * @param topOffset - The `top` value of the sticky element in pixels (usually the header height).
 */
const useIsSticky = (topOffset: number) => {
  const { ref: sentinelRef, inView } = useInView({
    threshold: 0,
    rootMargin: `-${topOffset}px 0px 0px 0px`,
    initialInView: true, // assume sentinel is visible (not sticky) on SSR to avoid shadow flash
  });
  return { sentinelRef, isSticky: !inView };
};
export default useIsSticky;
